const escapeCsvValue = (value) => {
  // JSON-style \" is not a CSV escape; treat it as a real quote then RFC-double it.
  const text = String(value ?? '').replace(/\\"/g, '"')
  if (text.includes('"') || text.includes(',') || text.includes('\n') || text.includes('\r')) {
    return `"${text.replace(/"/g, '""')}"`
  }
  return text
}

export default escapeCsvValue
